import { Controller } from '@hotwired/stimulus';
import markerSVG from '../../images/icons/map-marker.svg';
import { getMeta } from '../helpers';

export default class extends Controller {

    async connect() {

        let locations = this.element.dataset.locations;
        locations = locations ? JSON.parse(locations) : {};
        if (locations.length < 1) {
            return;
        }

        import('leaflet').then((L) => {
            Promise.all([
                import('protomaps-leaflet'),
                import('leaflet-gesture-handling'),
            ]).then(([protomapsL, GestureHandling]) => {
                this.element.removeAttribute('data-locations');

                const map = L.map(this.element, {
                    center: [locations[0]['lat'], locations[0]['lng']],
                    zoom: 12,
                    zoomSnap: false,
                    scrollWheelZoom: false,
                    gestureHandling: true,
                });

                protomapsL.leafletLayer({
                    attribution: '',
                    maxZoom: 16,
                    url: 'https://api.protomaps.com/tiles/v4/{z}/{x}/{y}.mvt?key=b281a9aefe0121e4',
                    flavor: 'grayscale',
                    lang: 'en'
                }).addTo(map);

                const markerIcon = L.icon({
                    iconUrl: markerSVG,
                    iconSize: [41, 64],
                    iconAnchor: [20, 64],
                    popupAnchor: [0, 0],
                });

                const markers = [];
                locations.forEach((data) => {
                    const marker = L.marker([data['lat'], data['lng']], { icon: markerIcon });
                    marker.addTo(map);
                    markers.push(marker);
                });

                if (locations.length > 1) {
                    const bounds = new L.featureGroup(markers).getBounds();
                    map.fitBounds(bounds, { padding: [50, 100] });

                    window.addEventListener('resize', () => {
                        setTimeout(() => {
                            const bounds = new L.featureGroup(markers).getBounds();
                            map.fitBounds(bounds, { padding: [50, 100] });
                        }, 10);
                    });
                }

                const resourcePath = getMeta('theme-url');
                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.register(resourcePath + 'map-worker.js').catch(console.error);
                }
            });
        })
    }
}
